<app-sidebar></app-sidebar>
<app-gabetas-log></app-gabetas-log>
